import React from "react";

import CheckOutlinedIcon from "@material-ui/icons/CheckOutlined";

import {
  ExceptionIcon,
  HashIcon,
  SealIcon,
} from "../../../components/common/iconography";
import { shouldBlockSealActionForRailcarVerification } from "../../../utils/railCarUtils";
import { shouldBlockSealActionForContainerVerification } from "./placedShipmentValidation";

export const getInboundSpeedDialActions = ({
  inboundShipment,
  isContainerNumberValidated,
  shipmentRailcarVerificationState,
  onOpenExceptionDialog,
  onOpenChecklistDialog,
  onOpenSealDialog,
  onOpenContainerNumberDialog,
  onOpenRailcarDialog,
  onSealBlocked,
  onSealBlockedByContainer,
}) => {
  const actionConfigs = [
    {
      condition: true,
      icon: <ExceptionIcon />,
      onClick: onOpenExceptionDialog,
      name: "Exceptions",
    },
    {
      condition: inboundShipment.checklist?.length > 0,
      icon: <CheckOutlinedIcon />,
      onClick: onOpenChecklistDialog,
      name: "Checklist",
    },
    {
      condition: inboundShipment.account?.trackInboundSeals,
      icon: <SealIcon />,
      onClick: () => {
        if (
          shouldBlockSealActionForRailcarVerification({
            requiresVerification:
              shipmentRailcarVerificationState.requiresVerification,
            isRailcarValidated:
              shipmentRailcarVerificationState.isRailcarValidated,
          })
        ) {
          onOpenRailcarDialog();
          onSealBlocked();
          return;
        }

        if (
          shouldBlockSealActionForContainerVerification({
            containerDrop: inboundShipment.containerDrop,
            isContainerNumberValidated,
          })
        ) {
          onOpenContainerNumberDialog();
          onSealBlockedByContainer();
          return;
        }

        onOpenSealDialog();
      },
      name: "Seal",
    },
    {
      condition: inboundShipment.containerDrop && !isContainerNumberValidated,
      icon: <HashIcon />,
      onClick: onOpenContainerNumberDialog,
      name: "Container",
    },
    {
      condition: shipmentRailcarVerificationState.requiresVerification,
      icon: <HashIcon />,
      onClick: onOpenRailcarDialog,
      name: "Railcar",
    },
  ];

  return actionConfigs.filter((action) => action.condition);
};
